/** Learning path (`.scratch/learning-path/spec.md` section 7). A step write answers with the item, which the cache takes. */
import { api } from './client';
import type { LearningItem, LearningOwnItem, LearningOwnKind, LearningPath } from './types';

/**
 * The four steps of a card's track (ux-bug-pass-6 D5): Not started, Started, Halfway, Done. `covered` is the server's,
 * set when the skill reaches the résumé; `skipped` is only on items skipped before the steps, and nobody sets it now.
 */
export type LearningItemSet = 'todo' | 'started' | 'halfway' | 'done';

const item = (id: string) => `/v1/learning-path/items/${encodeURIComponent(id)}`;

const own = (id: string) => `/v1/learning-path/own/${encodeURIComponent(id)}`;

/** What adding an own item sends; `status` is only set when an Undo puts one back at its step. */
export interface LearningOwnAdd { name: string; kind: LearningOwnKind; link?: string | null; status?: LearningItemSet }

export const learningApi = {
  addOwn: (body: LearningOwnAdd) => api<LearningOwnItem>('/v1/learning-path/own', { method: 'POST', body }),
  setOwnStatus: (id: string, status: LearningItemSet) => api<LearningOwnItem>(own(id), { method: 'PATCH', body: { status } }),
  removeOwn: (id: string) => api<void>(own(id), { method: 'DELETE' }),
  get: () => api<LearningPath>('/v1/learning-path'),
  setStatus: (id: string, status: LearningItemSet) => api<LearningItem>(item(id), { method: 'PATCH', body: { status } }),
};
